export const constants = {
  permissions: {
    createRequest: {
      id: 4540,
      mnemonic: "CREAR_SOLICITUD_PLANILLA",
      label: "Carga de solicitudes",
    },
    getRequests: {
      id: 4541,
      mnemonic: "CONSULTAR_SOLICITUD_PLANILLA",
      label: "Consulta de solicitudes",
    },
    approveRequest: {
      id: 4542,
      mnemonic: "APROBAR_SOLICITUD_PLANILLA",
      label: "Aprobar",
    },
    createReceipt: {
      id: 4543,
      mnemonic: "REGISTRAR_COMPROBANTE",
      label: "Registrar comprobante",
    },
    approveRequestPayment: {
      id: 4544,
      mnemonic: "APROBAR_PAGO_PLANILLA",
      label: "Aprobar Comprobantes",
    },
    userManagement: {
      id: 4545,
      mnemonic: "",
      label: "Gestión de usuario",
    },
  },
  validations: {
    required: {
      message: "Campo requerido",
    },
    email: {
      pattern: "[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$",
      message: "Email invalido",
    },
    rucFormat: {
      message: "Recuerda que el RUC está compuesto de 11 dígitos.",
    },
    docNumber: {
      message: (minLength: number) => {
        return minLength == 8
          ? `Debes ingresar ${minLength} dígitos`
          : `Debes ingresar al menos ${minLength} dígitos`;
      },
    },
    invalidFormat: {
      message: "Formato inválido",
    },
    invalidPhone: {
      message: "Debes ingresar 8 dígitos",
    },
    invalidPhoneFormat: {
      message: "Formato inválido. Por favor ingresa 8 dígitos",
    },
    minDigits: {
      message: "Clave de 6 dígitos",
    },
    numeric: {
      pattern: "^[0-9]*$",
      message: "Campo numérico",
    },
    alphabetic: {
      pattern: "[a-zA-ZÀ-ú ,.]*",
      message: "Campo alfabético",
    },
    alphanumeric: {
      pattern:
        "^(?:(?<Numbers>[0-9]{1})|(?<Alpha>[a-zA-Z]{1})|(?<Special>[^a-zA-Z0-9]{1})){4,100}$",
      message: "Campo alfanumérico",
    },
    invalidAmount: {
      message: "El monto no puede ser 0",
    },
    invalidCurrency: {
      message: (requiredCurrency: string) => "La moneda seleccionada debe ser " + requiredCurrency
    },
    loginExecutive: {
      alphanumeric: {
        pattern:
          "^(?:(?<Numbers>[0-9]{1})|(?<Alpha>[a-zA-Z]{1})|(?<Special>[^a-zA-Z0-9]{1})){8,20}$",
        message: "Debes ingresar al menos 8 caracteres alfanuméricos",
      },
      alphabetic: {
        pattern: "[a-zA-Z ,.]*",
        message: "Debes ingresar al menos 6 caracteres alfabéticos",
      },
    },
  },
  alerts: {
    verifyCompany: {
      nonExistentCompany: {
        swal: false,
        type: "warning",
        message:
          "Estimado, la empresa ingresada no esta en nuestros registros, si tiene inconvenientes puede comunicarse con Banco Falabella al 615-4315 o al correo operadores.extranet1@bancofalabella.com.pe",
        width: "auto",
      },
      existingCompany: {
        withoutAdmin: {
          swal: false,
          type: "warning",
          message:
            "Estimado cliente, ya tenemos un registro previo de la empresa que intenta crear, se procederá a crear el usuario administrador. Si tiene algún inconveniente puede comunicarse con Banco Falabella al 615-4315 o al correo operadores.extranet1@bancofalabella.com.pe",
          width: "auto",
        },
        withAdmin: {
          swal: true,
          type: "warning",
          message:
            "Estimado cliente, ya tenemos un registro previo de la empresa y del usuario administrador que intenta crear. Si tiene algún inconveniente puede comunicarse con Banco Falabella al 615-4315 o al correo operadores.extranet1@bancofalabella.com.pe",
          width: "auto",
        },
      },
    },
    nonMatchingPasswords: {
      type: "danger",
      message: "Verifica las claves ingresadas, deben coincidir",
      width: "auto",
    },
    capslock: {
      type: "warning",
      message: "Tienes activada la mayúscula de tu teclado.",
    },
    existingUser: {
      type: "warning",
      message: "Te informamos que los datos ingresados ya existen.",
    },
    credentials: {
      code:401,
      type: "danger",
      message:
        "La información ingresada es incorrecta, por favor inténtelo nuevamente",
    },
    sessionlimit: {
      code:401,
      type: "danger",
      message:
        "Sólo puedo tener una sesión activa",
    },
    bloqueo: {
      code:409,
      type: "danger",
      message:
        "Ha superado el máximo de intentos fallidos al ingresar su contraseña. Ve a la opción de Crear o recuperar contraseña",
    },
      passParteTel: {
      code:465,
      type: "danger",
      message:
        "La contraseña no puede ser igual a una parte del número de teléfono registrado, por favor ingresa una nueva clave",
    },
    passParteDoc: {
      code:466,
      type: "danger",
      message:
        "La contraseña no puede ser igual a una parte o totalidad del número de documento registrado, por favor ingresa una nueva clave",
    },
    invalidRuc: {
      type: "danger",
      message: "Recuerda que el RUC está compuesto de 11 dígitos.",
    },
    invalidToken: {
      type: "warning",
      message:
        "El código ingresado es incorrecto, por favor inténtelo nuevamente",
      width: "auto",
    },
    blockedSms: {
      type: "danger",
      message:
        "Tu clave SMS fue bloqueada. Comunícate con la banca Telefónica para desbloquearla",
      blocked: true,
    },
    expiredToken: {
      type: "warning",
      message:
        "Código expirado. Intente nuevamente a través de la opción reenviar código de acceso",
    },
    default: {
      code: 500,
      type: "warning",
      message: "Tuvimos un problema, por favor, inténtalo más tarde",
    },
    noResults: {
      emptySearch: {
        type: "no-results",
        message: "Te informamos que no existen\n archivos cargados",
      },
      emptyUserSearch: {
        type: "no-results",
        message:
          "No se encontraron usuarios para los criterios de búsqueda especificados",
      },
      noUsers: {
        type: "no-results",
        message: "Te informamos que no tienes perfiles creados",
      },
      unexpected: {
        type: "unexpected",
        message: "Tuvimos un problema,\n por favor, inténtalo más tarde.",
      },
    },
    requests: {
      invalidExtension: {
        type: "danger",
        message:
          "Recuerda que debes subir un archivo de extensión .txt, por favor inténtalo nuevamente.",
        width: "auto",
      },
      oversizeFile: {
        type: "danger",
        message:
          "El archivo excede el peso permitido, el máximo permitido es de 3mb.",
        width: "auto",
      },
      invalidFile: {
        type: "warning",
        message:
          "Ha ocurrido un error, por favor revise el archivo cargado, e intente subir uno nuevo.",
        width: "auto",
      },
    },
    receipts: {
      invalidExtension: {
        type: "danger",
        message:
          "Recuerda que debes subir un archivo de extensión .pdf, por favor inténtalo nuevamente.",
        width: "auto",
      },
      oversizeFile: {
        type: "danger",
        message:
          "El archivo excede el peso permitido, el máximo permitido es de 1mb.",
        width: "auto",
      },
      emptyFile: {
        type: "danger",
        message:
          "El archivo está vacío y/o pesa menos de permitido, recuerda que el mínimo es 10 kb y el máximo es de 1mb",
        width: "auto",
      },  
     
      nonMatchingAmounts: {
        type: "danger",
        message: "La suma del monto de los comprobantes cargados es diferente al monto de la solicitud, por favor revise la información cargada para poder avanzar la solicitud.",
        width: "auto",
      },
      maxReceipts: {
        type: "danger",
        message: "Recuerda, solo puedes cargar un máximo de 5 comprobantes.",
        width: "auto",
      },
    },
  },
  rules: {
    paymentMethods: [
      { value: 5, name: "EFECTIVO" },
      { value: 6, name: "CHEQUE" },
      { value: 7, name: "TRANSFERENCIA" },
    ],
    requestStates: [
      { value: 1, name: "CREADA" },
      { value: 2, name: "PENDIENTE" },
      { value: 4, name: "APROBADA" },
      { value: 6, name: "FORMALIZADA" },
      { value: 7, name: "RECHAZADA" },
      { value: 8, name: "DESERTADA" },
      { value: 5, name: "ACEPTADA" },
      { value: 12, name: "FINALIZADO" },
      { value: 13, name: "FINALIZADO PARCIAL" },
    ],
    requestTypes: [
      { value: 12, name: "Pago de Haberes" },
      { value: 11, name: "Pago Cuenta CTS" },
      { value: 10, name: "Actualización de Remuneraciones" },
    ],
    codes: {
      roles: {
        admin: {
          value: 1201,
          name: "ADMINISTRADOR",
          uri: "uriTech=ROL_OPERADOR@1201",
        },
        responsibleForRequests: {
          value: 1202,
          name: "PLANILLERO",
          uri: "uriTech=ROL_OPERADOR@1202",
        },
        treasurer: {
          value: 1203,
          name: "TESORERO",
          uri: "uriTech=ROL_OPERADOR@1203",
        },
        supervisor: {
          value: 1204,
          name: "SUPERVISOR",
          uri: "uriTech=ROL_OPERADOR@1204",
        },
      },
      requestTypes: {
        rrbb: {
          value: 10,
          name: "Actualización de Remuneraciones",
        },
        cts: {
          value: 11,
          name: "Pago Cuenta CTS",
        },
        paymentOfSalaries: {
          value: 12,
          name: "Pago de Haberes",
        },
      },
      requestStates: {
        created: { value: 1, name: "CREADA", emailTemplate: "BFPE_EXTRANET_SOLICITUD_CREADA" },
        pending: { value: 2, name: "PENDIENTE", emailTemplate: "BFPE_EXTRANET_SOLICITUD_CREADA" },
        approved: { value: 4, name: "APROBADA", emailTemplate: "BFPE_EXTRANET_SOLICITUD_APROBADA",emailTemplateBo:"BFPE_EXTRANET_SOLICITUD_APROBADA_BO" },
        formalized: { value: 6, name: "FORMALIZADA", emailTemplate: "BFPE_EXTRANET_SOLICITUD_FINALIZADA" },
        rejected: { value: 7, name: "RECHAZADA", emailTemplate: "BFPE_EXTRANET_SOLICITUD_FINALIZADA" },
        deserted: { value: 8, name: "DESERTADA", emailTemplate: "BFPE_EXTRANET_SOLICITUD_FINALIZADA" },
        confirmed: { value: 9, name: "ACEPTADA", emailTemplate: "BFPE_EXTRANET_SOLICITUD_FINALIZADA" },
        accepted: { value: 5, name: "ACEPTADA", emailTemplate: "BFPE_EXTRANET_SOLICITUD_FINALIZADA" },
        finalized: { value: 12, name: "FINALIZADO", emailTemplate: "BFPE_EXTRANET_SOLICITUD_FINALIZADA" },
        finalizedP: { value: 13, name: "FINALIZADO PARCIAL", emailTemplate: "BFPE_EXTRANET_SOLICITUD_FINALIZADA" },


      },
      paymentMethods: {
        cash: { value: 5, name: "EFECTIVO" },
        cheque: { value: 6, name: "CHEQUE" },
        transfer: { value: 7, name: "TRANSFERENCIA" },
      },
    },
  },
};
